// 邊詳情視圖（左側面板 + 邊表格）- 繁體中文
export default {
  common: {
    loading: "拼命加載中",
    copySuccess: "複製成功",
    noticeTitle: "提示",
    successTitle: "成功",
    errorTitle: "錯誤",
    totalPrefix: "共計 ",
    totalSuffix: " 條數據",
    unitTx: "筆",
    averagePrefix: "平均",
    noData: "暫無數據",
    viewInExplorer: "瀏覽器查看",
    notePrefix: "備註：",
    itemsUnit: "條",
    // Added for hash note table actions
    addSurvey: "加入調證",
    normalSurvey: "普通調證",
    importantSurvey: "重點調證",
    note: "備註",
    tipTitle: "提示",
  },
  fields: {
    ownership: "地址歸屬",
    watchingAddress: "觀察地址",
    inflow: "流入",
    outflow: "流出",
    firstInflow: "首筆轉入",
    crossChainSwap: "跨鏈換幣",
    sameIPShort: "同時段同IP",
    sameDeviceShort: "同設備賬號",
  },
  titles: {
    transactionDetails: "交易詳情",
    sameIP: "同時段同IP明細",
    sameDevice: "同設備明細",
    crossChain: "跨鏈交易詳情",
    hashNote: "哈希備註",
    coinJoin: "混幣交易詳情",
  },
  coinJoinTrace: {
    title: "混幣追踪",
    subtitle: "根據交易時間快速定位混幣交易並一鍵上圖",
    timeLabel: "追踪時間",
    rangeLabel: "追踪範圍",
    traceButton: "追踪上圖",
  },
  rangeOptions: {
    8: "8小時內",
    16: "16小時內",
    24: "24小時內",
    48: "48小時內",
  },
  messages: {
    notAllowSurvey: "此條內容不可調證",
    addressNotFound: "沒有查出該地址",
    downloadFailed: "下載失敗，請稍後重試",
    fetchFailed: "獲取數據失敗，請稍後重試",
    surveyAdded: "已加入調證",
    copySuccess: "複製成功",
  },
  leftEdge: {
    sender: "發送方",
    receiver: "接收方",
    crossChainTooltip:
      "bridgers 跨鏈可能涉及三個平台，通過第三方瀏覽器查看時可自行切換 OmniBridge、Bridgers、CrossChainX 查詢跨鏈數據",
    stargateTooltip:
      "支持Stargate跨鏈協議的資料追蹤，可通過'跨鏈追蹤'一鍵查詢跨鏈資料並上圖分析",
  },
  summary: {
    totalCountLabel: " 總筆數：",
    totalQuantityLabel: " 總數量：",
    averageQuantityLabel: "平均數量：",
  },
  sameIP: {
    topNotice:
      "當前結果為{timeRange}同IP登錄，如需其他時間範圍可前往【擴展配置】-【同時段同IP】進行時間範圍條件配置",
    topNoticePrefix: "當前結果為",
    topNoticeSuffix:
      "同IP登錄，如需其他時間範圍可前往【擴展配置】-【同時段同IP】進行時間範圍條件配置",
    labels: {
      ip: "IP",
      locationPrefix: "地理位置：",
      currentUser: "[當前用戶]",
      loginTime: "[登錄時間]",
      sameIPUser: "[同IP用戶]",
    },
    timeOptions: {
      ONE_DAY: "1天",
      THREE_DAY: "3天",
      ONE_WEEK: "1週",
      ONE_MONTH: "1月",
      THREE_MONTH: "3月",
      HALF_A_YEA: "半年",
      NOT_LIMIT: "不限",
    },
  },
  sameDevice: {
    columns: {
      manufacturer: "手機廠商",
      model: "手機型號",
      osVersion: "系統版本號",
      deviceId: "Device ID（UUID）",
      imei: "IMEI",
      mac: "MAC",
    },
  },
  firstRecord: {
    columns: {
      orderNo: "訂單號",
      txHash: "交易hash",
      quantity: "交易數量",
      time: "交易時間",
      actions: "操作",
    },
    actions: {
      note: "備註",
      survey: "調證",
      surveyNormal: "普通調證",
      surveyImportant: "重點調證",
    },
  },
  dealEdge: {
    filters: {
      time: "時間",
      startDate: "開始日期",
      endDate: "結束日期",
      amountRange: "金額區間",
      minAmount: "最小金額",
      maxAmount: "最大金額",
    },
    totalPrefix: "共計",
    totalSuffix: "條數據",
    buttons: {
      download: "下載",
      joinSurvey: "加入調證",
    },
    columns: {
      orderNo: "訂單號",
      txHash: "交易 hash",
      quantity: "交易數量",
      time: "交易時間",
      fromUserId: "發送方用戶ID",
      toUserId: "接收方用戶ID",
      note: "備註",
    },
    tooltips: {
      hashContainsMore:
        "該條交易 hash 包含更多代幣轉賬記錄，可通過交易數據詳情查看。",
    },
  },
  noteHistory: {
    dialogTitle: "備註歷史",
    totalPrefix: "共計：",
    columns: {
      noteContent: "備註內容",
      modifier: "變更人",
      modifiedTime: "變更時間",
    },
  },
  hashNoteDialog: {
    title: "備註",
    placeholder: "請輸入備註內容",
    history: "備註歷史",
    cancel: "取 消",
    confirm: "確 定",
    addSuccess: "添加 hash 備註成功",
    updateSuccess: "修改 hash 備註成功",
    deleteSuccess: "刪除 hash 備註成功",
  },
};
